import { render, staticRenderFns } from "./pedidosEspeciales.vue?vue&type=template&id=43e22992&scoped=true"
import script from "./pedidosEspeciales.vue?vue&type=script&lang=js"
export * from "./pedidosEspeciales.vue?vue&type=script&lang=js"
import style0 from "./pedidosEspeciales.vue?vue&type=style&index=0&id=43e22992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e22992",
  null
  
)

export default component.exports